import { Component } from '@angular/core';

@Component({
    selector: 'home',
    template: require('./home.component.html'),
})

export class HomeComponent {    

    constructor() {
    
    }
    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/home/home.component.ts
 **/